import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, MenuItem, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';

const API_URL = '/api/vehiculos';
const emptyForm = { placa: '', marca: '', modelo: '', color: '', cod_interno: '', nro_certificado_inscripcion: '', estado: 1 };

const Vehiculos = () => {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);

  const fetch = async () => {
    const res = await axios.get(API_URL);
    setRows(res.data);
  };
  useEffect(() => { fetch(); }, []);

  const handleOpen = (row = null) => {
    if (row) { setEditId(row.id); setForm({ placa: row.placa, marca: row.marca || '', modelo: row.modelo || '', color: row.color || '', cod_interno: row.cod_interno || '', nro_certificado_inscripcion: row.nro_certificado_inscripcion || '', estado: row.estado }); }
    else { setEditId(null); setForm(emptyForm); }
    setOpen(true);
  };
  const handleClose = () => { setOpen(false); setEditId(null); setForm(emptyForm); };

  const handleSave = async () => {
    if (!form.placa.trim()) { alert('La placa es obligatoria'); return; }
    try {
      if (editId) await axios.put(`${API_URL}/${editId}`, form);
      else await axios.post(API_URL, form);
      fetch();
      handleClose();
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar'); }
  };

  const toggleEstado = async (row) => {
    try {
      await axios.put(`${API_URL}/${row.id}`, { ...row, estado: row.estado ? 0 : 1 });
      fetch();
    } catch { alert('Error al cambiar estado'); }
  };

  const filtered = rows.filter(r =>
    `${r.placa} ${r.marca || ''} ${r.modelo || ''} ${r.color || ''}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1400 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold', color: '#222' }}>Vehículos</Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField placeholder="Buscar..." value={search} onChange={e => setSearch(e.target.value)} size="small"
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }} sx={{ flex: 1 }} />
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}>Nuevo Vehículo</Button>
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: '#1976d2' }}>
                {['Placa', 'Marca', 'Modelo', 'Color', 'Cód. Interno', 'Nro. Cert. Inscripción', 'Estado', 'Acciones'].map(h => (
                  <TableCell key={h} sx={{ color: '#fff', fontWeight: 'bold' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map(r => (
                <TableRow key={r.id} hover>
                  <TableCell><strong>{r.placa}</strong></TableCell>
                  <TableCell>{r.marca || '-'}</TableCell>
                  <TableCell>{r.modelo || '-'}</TableCell>
                  <TableCell>{r.color || '-'}</TableCell>
                  <TableCell>{r.cod_interno || '-'}</TableCell>
                  <TableCell>{r.nro_certificado_inscripcion || '-'}</TableCell>
                  <TableCell>
                    <Chip label={r.estado ? 'Activo' : 'Inactivo'} color={r.estado ? 'success' : 'default'} size="small"
                      onClick={() => toggleEstado(r)} sx={{ cursor: 'pointer' }} />
                  </TableCell>
                  <TableCell>
                    <IconButton color="primary" size="small" onClick={() => handleOpen(r)}><EditIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && <TableRow><TableCell colSpan={8} align="center">Sin registros</TableCell></TableRow>}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle><Typography variant="h6" fontWeight="bold">{editId ? 'Editar Vehículo' : 'Nuevo Vehículo'}</Typography></DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField label="Placa" value={form.placa} onChange={e => setForm(f => ({ ...f, placa: e.target.value.toUpperCase() }))} fullWidth required helperText="Ej: ABC123" />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField label="Marca" value={form.marca} onChange={e => setForm(f => ({ ...f, marca: e.target.value.toUpperCase() }))} fullWidth />
                <TextField label="Modelo" value={form.modelo} onChange={e => setForm(f => ({ ...f, modelo: e.target.value.toUpperCase() }))} fullWidth />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField label="Color" value={form.color} onChange={e => setForm(f => ({ ...f, color: e.target.value.toUpperCase() }))} fullWidth />
                <TextField label="Cód. Interno" value={form.cod_interno} onChange={e => setForm(f => ({ ...f, cod_interno: e.target.value }))} fullWidth />
              </Box>
              <TextField label="Nro. Certificado de Inscripción" value={form.nro_certificado_inscripcion} onChange={e => setForm(f => ({ ...f, nro_certificado_inscripcion: e.target.value }))} fullWidth />
              {editId && (
                <TextField select label="Estado" value={form.estado} onChange={e => setForm(f => ({ ...f, estado: Number(e.target.value) }))}>
                  <MenuItem value={1}>Activo</MenuItem>
                  <MenuItem value={0}>Inactivo</MenuItem>
                </TextField>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
            <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />}>Guardar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Vehiculos;
